import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { Icon } from "@iconify/react";
import { fields } from "../constants";
import { BrandingGuidelinesPageHeading } from "./BrandingGuidelinesPageHeading";
import { BrandingGuidelinesPageContent } from "./BrandingGuidelinesPageContent";
import { BrandingGuidelinesNextPage } from "./BrandingGuidelinesNextPage";

export const BrandingGuidelines = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "brandingGuidelinesPageHeading",
      children: <BrandingGuidelinesPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "brandingGuidelinesPageContent",
      children: <BrandingGuidelinesPageContent/>
    },
    {
      label: "Next Page",
      key: "brandingGuidelinesNextPage",
      children: <BrandingGuidelinesNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`/dedicated/corporate/media-centre?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
